/**
 * Clean y-axis tick values: 0 up to just past the maximum, stepping by 1/2/5 × 10^k so the
 * labels read as round numbers. The series here are counts, so the step never drops below 1.
 */
export function niceTicks(maxValue: number, targetIntervals = 4): number[] {
  if (maxValue <= 0) return [0, 1];
  const rough = maxValue / targetIntervals;
  const magnitude = 10 ** Math.floor(Math.log10(rough));
  const step = Math.max(
    1,
    [1, 2, 5, 10]
      .map((multiple) => multiple * magnitude)
      .find((candidate) => Math.ceil(maxValue / candidate) <= targetIntervals) ?? 10 * magnitude,
  );
  const top = Math.ceil(maxValue / step) * step;
  const ticks: number[] = [];
  for (let value = 0; value <= top; value += step) ticks.push(value);
  return ticks;
}

/**
 * Every how-many-th x position gets a label, so month labels never collide. Callers anchor the
 * stride to the LAST point, keeping the most recent month always labelled.
 */
export function xLabelStep(pointCount: number, innerWidth: number, labelWidth = 76): number {
  const maxLabels = Math.max(2, Math.floor(innerWidth / labelWidth));
  return Math.max(1, Math.ceil(pointCount / maxLabels));
}
